import type { ReactNode } from 'react';

import styles from '@/components/book/SectionRule.module.css';
import { Link } from '@/lib/navigation';

interface SectionRuleProps {
  label: ReactNode;
  /** `strong`: a 1px ink rule (Open at, Entries, The index). `hairline`: a 1px rule-coloured one. */
  strength?: 'strong' | 'hairline';
  as?: 'h2' | 'h3';
  href?: string;
  id?: string;
  /** Controls at the right of the rule, e.g. Arrange. */
  aside?: ReactNode;
}

/** The rule and italic label that open a section. */
export function SectionRule({ label, strength = 'strong', as: Heading = 'h2', href, id, aside }: SectionRuleProps) {
  return (
    <div className={[styles.rule, strength === 'hairline' ? styles.hairline : ''].filter(Boolean).join(' ')}>
      <Heading className={styles.label} id={id}>
        {href ? <Link to={href}>{label}</Link> : label}
      </Heading>
      {aside != null && <div className={styles.aside}>{aside}</div>}
    </div>
  );
}
